import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const TotalElement = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  padding: 15px 0;
  border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};

  > div {
    &:not(:last-child) {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};
    }
  }

  p {
    margin: 0;
    font-size: 14px;

    &.label {
      font-weight: 600;
    }
  }

  .price {
    font: ${font('default', 'bold', '28px/1')};
    margin: 5px 0 10px;
  }

  span {
    display: block;
  }
`

export const Title = styled.div`
  padding-bottom: 10px;
  border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};
`
